import { ReactElement } from 'react';
import { GlossaryItem, GlossaryModal } from '@Components/GlossaryModal/GlossaryModal';

export const SPEND_AND_EFFECT_GLOSSARY_DEFINITIONS: Record<string, string> = {
  Actualized:
    'The spend/effect for a given tactic after making necessary corrections for demand gen <> demand capture dynamics. This is the true, causal form of each figure.',
  Added:
    'Indicates spend/effect being added to a demand gen channel, because it has stimulated downstream spend/effect in a demand capture channel.',
  Reduced:
    'Indicates spend/effect being subtracted from a demand capture channel, because it was ultimately caused by an upstream demand generation channel.',
  'Demand Capture':
    'Strategies and tactics aimed at converting existing consumer interest in a product, in a context where the consumer was actively seeking it out. Examples would include branded search, branded shopping, etc.',
  'Demand Generation':
    'Strategies and tactics aimed at introducing a product to a consumer, in a context where they were not actively seeking it out. Examples would include television, podcasts, social media, etc.',
  Direct:
    'The spend/effect for a given tactic prior to any correction for demand gen <> demand capture dynamics.',
  'Direct Spend':
    "The amount of investment directly tied to a given tactic; the accountant's version of spend.",
  'Actualized Spend':
    "The amount of investment caused by a given tactic; the economist's version of spend. For demand gen tactics, this will often be greater than the direct spend; for demand capture tactics, it will often be less.",
  'Direct Effect': 'The proximate effect of a given tactic; a last-touch accounting of effect.',
  'Actualized Effect':
    'The ultimate effect caused by a given tactic; a multi-touch accounting of effect. For demand gen tactics, this will often be greater than the direct effect; for demand capture tactics, it will often be less.'
};

interface SpendAndEffectGlossaryProps {
  show: boolean;
  setShow: (value: boolean) => void;
}

export const SpendAndEffectGlossary = ({
  show,
  setShow
}: SpendAndEffectGlossaryProps): ReactElement => {
  const glossary: GlossaryItem[] = Object.keys(SPEND_AND_EFFECT_GLOSSARY_DEFINITIONS)
    .sort()
    .map(key => ({ term: key, definition: SPEND_AND_EFFECT_GLOSSARY_DEFINITIONS[key] }));

  return (
    <GlossaryModal
      show={show}
      setShow={setShow}
      title='Spend and Effect Share Glossary'
      initialGlossary={glossary}
    />
  );
};
